var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',{ref:"canvas",staticClass:"blog-avatar img-fluid",attrs:{"width":_vm.w,"height":_vm.h,"title":_vm.blog.title},on:{"click":function($event){$event.preventDefault();_vm.openBlog(_vm.blog)}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ac31a772","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/BlogAvatar.vue
// module id = Pk1B
// module chunks = 0